var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getProp, postGql } from '../common/utils';
import { initializeAsync, initializeSync, getFnSyncPayload } from '../common/fn';
export default function ({ context, publicCredential, options = {} }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!context || !publicCredential) {
            return;
        }
        try {
            const parsedContext = JSON.parse(atob(context));
            if (!parsedContext.fnData) {
                throw 'Invalid context!';
            }
            initializeAsync(parsedContext.fnData);
            yield initializeSync(parsedContext.fnData);
            const challengeInfo = {
                autoSmsOtp: false,
            };
            Object.keys(parsedContext.exp || {}).forEach((experiment) => {
                if (experiment === 'autoSmsOtp') {
                    challengeInfo.autoSmsOtp = parsedContext.exp[experiment].value;
                }
            });
            const response = yield postGql({
                data: {
                    operationName: 'getOtpChallengeOperation',
                    query: '',
                    csrfNonce: parsedContext.csrfNonce,
                    variables: {
                        clientInfo: {
                            fnId: parsedContext.fnData.fnSessionId,
                            ctxId: parsedContext.ctxId,
                            rData: getFnSyncPayload(),
                        },
                        credentials: {
                            credentialValue: publicCredential,
                            credentialType: 'EMAIL',
                        },
                        challengeInfo,
                    },
                },
                baseUri: options.baseUri,
            });
            const getOtpChallengeRes = getProp(response, 'data.otp.getOtpChallenge', {});
            if (response.errors) {
                return null;
            }
            // User exists on file but is not eligible
            if (Array.isArray(getOtpChallengeRes.challenges) && getOtpChallengeRes.challenges.length === 0) {
                return [];
            }
            // User does not exist on file
            if (!getOtpChallengeRes.challenges) {
                return null;
            }
            // User exists on file and is eligible for the OTP experience
            return {
                notified: !!getOtpChallengeRes.challenges.find((challenge) => challenge.notified),
                context: btoa(JSON.stringify(Object.assign(Object.assign({}, parsedContext), { lookupResponse: response, publicCredential }))),
            };
        }
        catch (err) {
            console.log(err);
            return null;
        }
    });
}
